/*------------------------------------------------------------------
Import styles
------------------------------------------------------------------*/
import 'lazysizes';
import 'lazysizes/plugins/bgset/ls.bgset';
import $ from 'jquery'
import parsley from 'parsleyjs'
document.addEventListener('lazybeforeunveil', function (e) {
    var bg = e.target.getAttribute('data-bg');
    if (bg) e.target.style.backgroundImage = 'url(' + bg + ')';
});

import './../styles/style.scss';


/*------------------------------------------------------------------
Helpers
------------------------------------------------------------------*/

const query = document.querySelector.bind(document);
const queryAll = document.querySelectorAll.bind(document);

/*------------------------------------------------------------------
Import modules
------------------------------------------------------------------*/

import './components/imageText';
import './components/inview';
import './components/mobileMenu';
import './components/search';
import './components/grid';
import './components/banner';
import './components/matchHeight';
import './components/videoModal';
import './components/tabbed';
import './components/accordionBlock';
import './components/productSlider';
import './components/linksSlider';
import './components/filters';
import './components/locators';

/*------------------------------------------------------------------
Import external
------------------------------------------------------------------*/


$(() => {

    let $body = $('body');

    $body.on('click', '.js-toggle-children-items', (e) => {
        e.preventDefault();
        console.log('click');

        let $this = $(e.currentTarget);
        let $childMenu = $this.next('.js-children');

        if ($this.hasClass('active')) {
            $childMenu.slideUp();
            $this.removeClass('active');
        } else {
            $childMenu.slideDown();
            $this.addClass('active');
        }
    });

});

document.addEventListener('DOMContentLoaded', () => {

    let emailInput = query('#MemberLoginForm_LoginForm_Email');
    if (emailInput) emailInput.dataset.lpignore = true;

    let passwordInput = query('#MemberLoginForm_LoginForm_Password');
    if (passwordInput) passwordInput.dataset.lpignore = true;

    /*------------------------------------------------------------------
    Sticky header  
    ------------------------------------------------------------------*/

    let previousScrollPosition = 0;
    let scrollDelta = 5;
    let header = query('.header');
    let headerHeight = (header) ? header.clientHeight / 3 : 0;

    const stickyHeader = () => {
        let st = window.scrollY;
        if (Math.abs(previousScrollPosition - st) <= scrollDelta) return;
        if (st === 0) {
            header.classList.remove('nav-down');
            header.classList.remove('nav-up');
        } else if (st > previousScrollPosition && st > headerHeight) {
            header.classList.remove('nav-down');
            header.classList.add('nav-up');
        } else {
            if (st + window.innerHeight < document.body.clientHeight) {
                header.classList.add('nav-down');
                header.classList.remove('nav-up');
            }
        }
        previousScrollPosition = st;
    }

    window.addEventListener('scroll', stickyHeader);

    [...queryAll('.js-hero-block')].forEach(heroBlock => {
        let speed = 7;
        let image = heroBlock.querySelector('.js-hero-block-image');
        let elementTop = heroBlock.getBoundingClientRect();
        window.addEventListener('scroll', () => {
            var scrolled = window.scrollY;
            var shiftDistance = (elementTop.top - scrolled) / speed;
            image.style.transform = `translate3d(0, ${shiftDistance}px, 0)`;
        });

    });

    [...queryAll('.js-postload')].forEach(item => {
        item.classList.remove('js-postload');
    });

});






let closeButton = document.querySelector('.js-close-enquiry-modal');

if (closeButton) {
    closeButton.addEventListener('click', function () {
        document.body.classList.remove('product-enquiry-form-is-active');
    });
}

let openButtonAlt = document.querySelector('.js-show-enquiry-form-popup-alt');

if (openButtonAlt) {
    openButtonAlt.addEventListener('click', function (e) {
        e.preventDefault();
        document.body.classList.add('product-enquiry-form-is-active');
    });
}

let openButton = document.querySelector('.js-show-enquiry-form-popup');

if (openButton) {
    openButton.addEventListener('click', function (e) {
        e.preventDefault();
        document.body.classList.add('product-enquiry-form-is-active');
    });
}


$(() => {

    let $contactForm = $('#Form_ProductEnquiryForm');

    if ($contactForm.length) {
        $contactForm.parsley().on('form:submit', () => {
            $.ajax({
                type: 'POST',
                url: $contactForm.attr('action'),
                data: $contactForm.serialize()
            }).done(function (response) {
                $contactForm[0].reset();
                $contactForm.replaceWith(`<h2 style="margin-top:1rem;width:100%">Thank you for your enquiry, <br>one of our expert sales engineers will be in touch shortly</h2><p>`);
            }).fail(function (response) {
                $(`<p>${response.data}</p>`).insertBefore($contactForm);
            });
            return false;
        });
    }

});


window.addEventListener('scroll', () => {
    if ($(window).scrollTop() > 100) {
        $('.js-show-enquiry-form-popup').addClass('visible');
    } else {
        $('.js-show-enquiry-form-popup').removeClass('visible');
    }
});

/*------------------------------------------------------------------
Banner Video
------------------------------------------------------------------*/

import YouTubePlayer from 'youtube-player';


document.addEventListener('DOMContentLoaded', () => {

    const throttle = (callback, limit) => {
        var wait = false;
        return () => {
            if (!wait) {
                callback.call();
                wait = true;
                setTimeout(() => wait = false, limit);
            }
        }
    }

    const resizeVideo = () => {
        let bannerVideo = query('.js-banner-video');
        let banner = query('.js-banner');
        let bw = banner.clientWidth;
        let bh = banner.clientHeight;
        let ratio = 1920 / 1080;
        if (bw / bh < ratio) {
            bannerVideo.style.height = bh + 'px';
            bannerVideo.style.width = bh * ratio + 'px';
        } else {
            bannerVideo.style.height = bh * ratio + 'px';
            bannerVideo.style.width = bw + 'px';
        }
    }


    if (queryAll('#video-player').length) {
        let bannerVideo = query('.js-banner-video');

        let player = YouTubePlayer('video-player', {
            color: 'white',
            controls: 0,
            autoplay: 1,
            rel: 0,
            fs: 0,
            modestbranding: 1
        });

        player.loadVideoById(bannerVideo.dataset.videoId);
        player.mute();
        player.playVideo().then(() => { query('#video-player').style.opacity = 1 });
        window.addEventListener('resize', throttle(resizeVideo, 100));
        resizeVideo();
        player.on('stateChange', (e) => { if (e.data == YT.PlayerState.ENDED) player.playVideo() });
    }


});
